import {
    RECEIVE_RELEASED_WORK_INSTRUCTIONS,
    REMOVE_WORK_INSTRUCTION,
    UPDATED_RELEASED_WORK_INSTRUCTIONS
} from '../../actions/wi_actions';
import { omit, mapKeys} from "lodash"
var _ = require('lodash')

const released_reducer = (oldState = {}, action) => {
    Object.freeze(oldState);
    let updatedWipInfo = _.cloneDeep(oldState)

    switch (action.type) {
        case RECEIVE_RELEASED_WORK_INSTRUCTIONS:
            const WorkInstructions = mapKeys(action.workInstructions, "_id")
            let normalizedWorkInstructions = { ...oldState, ...WorkInstructions }
            return normalizedWorkInstructions
        case UPDATED_RELEASED_WORK_INSTRUCTIONS:
            updatedWipInfo[action.workInstruction._id] = action.workInstruction
            return updatedWipInfo
        case REMOVE_WORK_INSTRUCTION:
            return omit(oldState, action.workInstruction.wip_id)
        default:
            return oldState;
    }
};

export default released_reducer;